var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"input-container"},[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('input',{class:[
      _vm.error
        ? '!border-red-400 dark:!border-red-400'
        : 'border-slate-200 dark:border-slate-600',
      'bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100',
    ],style:(_vm.styles),attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":_vm.onChange,"blur":_vm.onBlur}}),_vm._v(" "),(_vm.helpText)?_c('p',{staticClass:"help-text"},[_vm._v(_vm._s(_vm.helpText))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('span',{staticClass:"message"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("masked")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }